module.exports = {
  iot: '/',
  env: 'production'
}



// WEBPACK FOOTER //
// ./src/utils/env.config.js